import {FileSizeMetric} from '../constants';
import {FileSizeSubTypeLabel} from '../locales';

export const getFileSizeSubTypeLabel = (subType: FileSizeMetric) =>
	FileSizeSubTypeLabel[subType];

export default getFileSizeSubTypeLabel;
